import { Entity, LiveData } from '@toeverything/infra';
import type { Location } from 'history';
import { Observable, switchMap } from 'rxjs';

import type { WorkbenchService } from '../../workbench';

export class Navigator extends Entity {
  constructor(private readonly workbenchService: WorkbenchService) {
    super();
  }

  private readonly history$ = this.workbenchService.workbench.activeView$.map(
    view => view.history
  );

  private readonly location$ = LiveData.from(
    this.history$.pipe(
      switchMap(
        history =>
          new Observable<{ index: number; entries: Location[] }>(subscriber => {
            subscriber.next({ index: history.index, entries: history.entries });
            return history.listen(() => {
              subscriber.next({
                index: history.index,
                entries: history.entries,
              });
            });
          })
      )
    ),
    { index: 0, entries: [] }
  );

  readonly backable$ = this.location$.map(({ index, entries }) => {
    //DNB_FIX
    if (!BUILD_CONFIG.isElectron) {
      return 'navigation' in window && window.navigation.canGoBack;
    } else {
      return index > 0 && entries.length > 1;
    }
  });

  readonly forwardable$ = this.location$.map(({ index, entries }) => {
    //DNB_FIX
    if (!BUILD_CONFIG.isElectron) {
      return 'navigation' in window && window.navigation.canGoForward;
    } else {
      return index < entries.length - 1;
    }
  });

  back() {
    if (!BUILD_CONFIG.isElectron) {
      if ('navigation' in window) {
        window.navigation.back();
      }
    } else {
      this.history$.value.back();
    }
  }

  forward() {
    if (!BUILD_CONFIG.isElectron) {
      if ('navigation' in window) {
        window.navigation.forward();
      }
    } else {
      this.history$.value.forward();
    }
  }
}
